<template>
  <div>
    <bar-chart
      :chart-data="data"
      :title="$t('smi_sri.individual_student_sat')"
    ></bar-chart>
  </div>
</template>
<script>
import BarChart from "@/components/Base/BarChart";
export default {
  components: { BarChart },
  props: ["chartData"],
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    this.data = this.chartData;
  }
};
</script>
